export default "__VITE_ASSET__k78z8YV5__"